import React from "react";
import { useTranslation } from "react-i18next";

// Icons
import { HiOutlineDocumentDownload } from "react-icons/hi";
import { SlBulb } from "react-icons/sl";
import { FaAtom } from "react-icons/fa";

// Components
import Typography from "../../components/Typography";

// Styles
import styles from "./style.module.scss";


const options = [
  'upload_material',
  'instant_solutions',
  'convert_to_tools'
]

const EmptyState: React.FC = () => {
  const { t } = useTranslation();

  const renderOption = (option: string) => {
    let icon = null;
    let title = null;
    let description = null;

    switch (option) {
      case 'upload_material':
        icon = <HiOutlineDocumentDownload className={styles.option_icon} />;
        title = t("generate.snapshot.upload_material.title");
        description = t("generate.snapshot.upload_material.description");
        break;
      case 'instant_solutions':
        icon = <SlBulb className={styles.option_icon} />;
        title = t("generate.snapshot.instant_solutions.title");
        description = t("generate.snapshot.instant_solutions.description");
        break;
      case 'convert_to_tools':
        icon = <FaAtom className={styles.option_icon} />;
        title = t("generate.snapshot.convert_to_tools.title");
        description = t("generate.snapshot.convert_to_tools.description");
        break;
      default:
        break;
    }

    return (
      <div className={styles.option} key={option}>
        {icon}
        <div className={styles.optionContent}>
          <Typography variant="p">
            {title}
          </Typography>
          <Typography variant="p">
            {description}
          </Typography>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.root}>
      {options.map((option) => renderOption(option))}
    </div>
  )
}

export default EmptyState
